import {
	createRelayResource,
	RELAY_RESOURCE_TYPE,
} from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import ServiceDeskPortalSettingsRelayQuery, {
	type ClassicPortalSettingsQuery,
} from '../__generated__/ClassicPortalSettingsQuery.graphql';

export const serviceDeskPortalClassicSettingsResource =
	createRelayResource<ClassicPortalSettingsQuery>({
		type: `${RELAY_RESOURCE_TYPE}_SERVICE_DESK_PORTAL_CLASSIC_SETTINGS`,
		getQuery: (_, { tenantContext: { cloudId } }) => ({
			parameters: ServiceDeskPortalSettingsRelayQuery,
			variables: { cloudIdString: cloudId, cloudId },
			options: { fetchPolicy: 'store-and-network' },
		}),
		isCritical: true,
	});
